import { isAdminV2MenuItemKey } from './adminShellConfig';

const ADMIN_ICON_BG = '#009587';
const ADMIN_DASHBOARD_ICON_BG = '#1d252c';

export function getAdminShellMenuItems(t, selectedMenuItem) {
  return [
    {
      key: 'adminDashboard',
      label: t('dashboard_menu'),
      path: '/admin/',
      image: 'dashboard-stacked-icon.png',
      bgColor: ADMIN_DASHBOARD_ICON_BG,
      menuItemKey: 'admin-dashboard'
    },
    {
      key: 'adminSubscriptions',
      label: t('admin_subscriptions'),
      path: '/admin/subscriptions/',
      image: 'visits-stacked-icon.png',
      menuItemKey: 'admin-subscriptions'
    },
    {
      key: 'adminSubscriptionPlans',
      label: t('admin_subscription_plans'),
      path: '/admin/subscriptionplans/',
      image: 'poll.png',
      menuItemKey: 'admin-subscription-plans'
    },
    {
      key: 'adminTemplateSubscriptions',
      label: t('admin_template_subscriptions'),
      path: '/admin/templatesubscriptions/',
      image: 'industry.png',
      menuItemKey: 'admin-template-subscriptions'
    },
    {
      key: 'adminFormTemplates',
      label: t('admin_form_templates'),
      path: '/admin/customforms/',
      image: 'industry.png',
      menuItemKey: 'admin-form-templates'
    },
    {
      key: 'adminPromotions',
      label: t('admin_promotions'),
      path: '/admin/promotions/',
      image: 'poll.png',
      menuItemKey: 'admin-promotions'
    },
    {
      key: 'adminReleaseNotes',
      label: t('admin_release_notes'),
      path: '/admin/releaseAnnouncement/',
      image: 'file-document.png',
      menuItemKey: 'admin-release-notes'
    },
    {
      key: 'adminDashboardAccess',
      label: t('admin_dashboard_access'),
      path: '/admin/dashboardaccess/',
      image: 'poll.png',
      menuItemKey: 'admin-dashboard-access'
    },
    {
      key: 'adminPricingManagement',
      label: t('pricing_management'),
      path: '/pricingmanagement',
      image: 'pricing-management.png',
      menuItemKey: 'pricingmanagement'
    }
  ].map((item) => ({
    ...item,
    bgColor: item.bgColor || ADMIN_ICON_BG,
    fieldPie2: isAdminV2MenuItemKey(item.menuItemKey),
    visible: true,
    selected: item.menuItemKey === selectedMenuItem
  }));
}
